import CateringRoutes from "./CateringRoutes";

export default CateringRoutes;